import gql from 'graphql-tag';

export const IS_EVENT_SCHEDULED_FOR_USER = gql`
  query IsEventScheduledForUser($email: String!, $eventSlug: String!) {
    isEventScheduledForUser(input: { email: $email, eventSlug: $eventSlug }) {
      email
      eventSlug
      isScheduled
    }
  }
`;

export const GET_EMPLOYER_ONBOARDING_STATUS = gql`
  query FindOnboardingStatus($data: CoreOnboardingKeys!) {
    findOnboarding(data: $data) {
      id
      status
      data {
        id
        progress
        callEventId
      }
    }
  }
`;

export const UPSERT_EMPLOYER_ONBOARDING = gql`
  mutation UpsertEmployerOnboarding($data: CoreOnboardingInput!) {
    upsertOnboarding(data: $data) {
      id
      status
      data {
        id
        progress
        callEventId
      }
    }
  }
`;

export const FIND_ONBOARDING = gql`
  query FindOnboarding($data: CoreOnboardingKeys!, $id: ID!) {
    findOnboarding(data: $data) {
      id
      status
      version
      data {
        id
        progress
        callEventId
        companyLegalName
        fein
        address {
          line1
          line2
          city
          state
          zipCode
        }
        discussionTopics
        nextAction
        numOfEmployees
        numOfContractors
        hasRemoteEmployees
        remoteWorkerStates
      }
    }
    coreCompany(id: $id) {
      name
      whatBroughtYouToBambee
    }
  }
`;
